import Button from "../../../custom/button/button";
import { ReactComponent as Add } from "../../../assets/Plus Math.svg";
import { ReactComponent as Delete } from "../../../assets/deleteIcon.svg";
import { ReactComponent as View } from "../../../assets/view.svg";
import { ReactComponent as Cancel } from "../../../assets/cancel.svg";
// import { ReactComponent as DownloadPdf } from "../../../assets/Export Pdf.svg";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import styles from "../dashboardPage.module.scss";
import { App, Modal, Spin, Table } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createUpdateInstitution,
  deleteInstitution,
  getInstitutionByApplicantId,
} from "../../../utils/request";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";
import { ColumnsType } from "antd/es/table";
import { formatDate } from "../../../utils/formatDate";
import { limitString } from "../../../utils/limitString";
import InstitutionForm from "../../../components/onboardingSteps/institution/form";

const Institute = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const user = useAtomValue(userAtom);

  const queryClient = useQueryClient();
  const { notification } = App.useApp();

  const { data, isLoading } = useQuery({
    queryKey: ["get-institution"],
    queryFn: () => getInstitutionByApplicantId(user?.applicantId ?? ''),
  });

  const createUpdateInstitutionMutation = useMutation({
    mutationFn: createUpdateInstitution,
  });

  const deleteInstitutionMutation = useMutation({
    mutationFn: deleteInstitution,
  });

  const handleCreateUpdateInstitution = async (values: Institution) => {
    const formData = new FormData();

    formData.append("Id", "0");
    formData.append("ApplicantId", user?.applicantId ?? '');
    formData.append("InstitutionName", values.institutionName);
    formData.append("Discipline", values.discipline);
    formData.append("CGPA", values.cgpa);
    formData.append("StartDate", values.startDate);
    formData.append("EndDate", values.endDate);
    if (values.upload) {
      formData.append("Certificate", values.upload);
    }

    try {
      await createUpdateInstitutionMutation.mutateAsync(formData, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          queryClient.refetchQueries({ queryKey: ["get-institution"] });
          setShowModal(false);
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const handleDeleteInstitution = async (id: number) => {
    try {
      await deleteInstitutionMutation.mutateAsync(id, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          queryClient.refetchQueries({ queryKey: ["get-institution"] });
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const column: ColumnsType<InstitutionData> = [
    {
      title: "S/N",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Institution Attended",
      dataIndex: "institutionName",
      key: "institutionName",
    },
    {
      title: "Discipline",
      dataIndex: "discipline",
      key: "discipline",
    },
    {
      title: "CGPA",
      dataIndex: "cgpa",
      key: "cgpa",
    },
    {
      title: "Certificate",
      dataIndex: "certificateUrl",
      key: "certificateUrl",
      render: (text: string) => <span>{limitString(text)}</span>,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (text: string) => <span>{formatDate(text)}</span>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (text: string) => <span>{formatDate(text)}</span>,
    },
    {
      title: "Action",
      dataIndex: "TransDate",
      key: "TransDate",
      render: (_, record) => (
        <span>
          {
            <>
              <View
                onClick={() => {
                  navigate(`/view-institute/${record?.id}`);
                }}
                style={{ marginInlineEnd: "1rem" }}
              />

              <Delete onClick={() => handleDeleteInstitution(record?.id)} />
            </>
          }
        </span>
      ),
    },
  ];

  const institutionData = data?.data ?? [];

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <>
      <PageLayout
        heading="Institution"
        headerActions={
          <>
            <Button
              onClick={() => {
                setShowModal(true);
              }}
              iconBefore={<Add />}
              text="Add"
            />
            {/* <Button
              iconBefore={<DownloadPdf />}
              text="Download"
              bgColor="#CE9938"
            /> */}
          </>
        }
      ></PageLayout>

      <Table
        columns={column}
        dataSource={institutionData}
        className={styles.row}
        rowKey={"DueYear"}
        scroll={{ x: 400 }}
        //   pagination={{ current: currentPage, pageSize: pageSize, onChange: handlePaginationChange, position: ["bottomCenter"] }}
        pagination={false}
      />

      <Modal
        open={showModal}
        footer=""
        onCancel={() => setShowModal(false)}
        centered
        closeIcon={<Cancel />}
        width={900}
      >
        <div className={styles.modalContent}>
          <div>
            <p>Institution</p>
            <p>Input details of your attended institution (if any)</p>
          </div>

          <hr />

          <br />

          <InstitutionForm
            editIndex={null}
            isLoading={createUpdateInstitutionMutation?.isPending}
            buttonText="Create"
            onSubmit={handleCreateUpdateInstitution}
          />
        </div>
      </Modal>
    </>
  );
};

export default Institute;
